/* eslint-disable react/prop-types */
import CategoryItem from "./components/CategoryItem";

function CategoriesList({backgroundColor = "#ffffff", sectionTitle, sectionContainer, categoriesList, categoryBackgroundColor}) {

  // Do not render the component if categoriesList is empty or undefined
  if (!categoriesList || categoriesList.length === 0) {
    return null;
  }

  return (
    <div className="section-category-list py-2 md:py-8" style={{backgroundColor: backgroundColor}}>
      <div className="2xl:container mx-auto px-2 2xl:px-0">
        {sectionTitle && (
          <h2 className="text-4xl font-bold mb-5 text-center font-secondary text-primary-studio">
            {sectionTitle}
          </h2>
        )}
        <div className="flex justify-around flex-wrap">
          {categoriesList.map((category) => (
            <CategoryItem key={category.category.term_id} category={category} sectionContainer={sectionContainer} categoryBackgroundColor={categoryBackgroundColor} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default CategoriesList;
